import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-spinner-button-spinner',
    template: `
        <mat-progress-spinner diameter="22" strokeWidth="2" mode="indeterminate"></mat-progress-spinner>
    `,
    styleUrls: ['./spinner-button-spinner.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpinnerButtonSpinnerComponent {}
